(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .constant('THEMES', [ 'aka', 'pl', 'ro', 'en' ]);
})();
